import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

import getParams from '@dashboard/services/getParams';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import logException from '@dashboard/services/logException';
import Logo from '@dashboard/components/Logo';
import Spinner from '@dashboard/components/Spinner';

import { connectPaymentGateway } from './helpers';
import StripeLogo from './stripe.png';

export default function SellerConnectStripe() {
  const { setSeller, token, sellerId } = useAuth();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    async function connectStripe() {
      const urlParams = getParams(location.search);

      try {
        if (urlParams.error || urlParams.error_description) {
          if (urlParams.error === 'access_denied') {
            if (urlParams.state) {
              history.push(urlParams.state.replace('/dashboard', ''));
            } else {
              history.push('/settings/stripe');
            }

            return;
          } else {
            throw new Error();
          }
        }

        const response = await connectPaymentGateway(urlParams, sellerId, 'stripe', token);

        if (response.data) {
          setSeller(response.data);

          if (urlParams.state) {
            history.push(urlParams.state.replace('/dashboard', ''));
          } else {
            history.push('/');
          }
        } else {
          throw new Error();
        }
      } catch (error) {
        window.alert('Failed to connect your Stripe account. Please try again or contact support.');

        logException({
          message: 'Failed to connect Stripe account',
          urlParams,
          sellerId,
          token,
          error,
        });

        if (urlParams.state) {
          history.push(urlParams.state.replace('/dashboard', ''));
        } else {
          history.push('/settings/stripe');
        }
      }
    }

    connectStripe();
  }, [location, sellerId, token, history, setSeller]);

  return (
    <>
      <div className="mb-8 text-center">
        <Spinner className="mx-auto w-12 h-12 mb-8" />
        <h1 className="text-4xl">Connecting to Stripe</h1>
      </div>

      <div className="flex flex-row justify-between w-full relative gap-x-10">
        <div className="w-full flex items-center border border-gray-100 rounded p-4 bg-white z-10">
          <div className="h-auto mx-auto">
            <Logo size={80} />
          </div>
        </div>
        <div className="bg-gray-100 my-auto absolute top-0 bottom-0 w-full h-px" />
        <div className="w-full flex items-center border border-gray-100 rounded p-4 bg-white z-10">
          <img className="h-20 mx-auto" src={StripeLogo} />
        </div>
      </div>
    </>
  );
}
